import React from 'react';
import { useSelector } from 'react-redux';
import CardProductPerCategory from './CardProductPerCategory';
import MenuSlider from './MenuSlider';

const ProductPerCategory = () => {
  const { categories } = useSelector(state => state.highlight.productPerCategory);

  return (
    <div className='product-per-category'>
      <div className='product-per-category-head'>
        <h2>Belanja per Kategori</h2>
        <div className="see-all-at-category">Lihat Semua</div>
      </div>
      <MenuSlider />
      <div className="ppc-cards">
        {categories.map(category => (
          <CardProductPerCategory key={category.id} category={category.title} img={category.img} alt={category.name} />
        ))}
      </div>
    </div>
  )
}

export default ProductPerCategory
